import React from "react";

import HeaderImage from "assets/images/nzCaseStudy/header.png";
import FooterImage from "assets/images/nzCaseStudy/footerNZ.png";

import "../styles.css";

const NZReportPDFPage4 = ({ whyAreWeRetrofittingOurHome, whatLessonsDidWeLearn, whatElseNeedsToBeDone }) => {
    return (
        <div className="bodyNZPDF">
            <img src={HeaderImage} alt="header" />
            <div
                className="pageContainerNZPDF"
                style={{
                    flex: 1,
                    background: "#fff",
                    margin: "0 20px",
                    padding: "20px 0",
                    display: "flex",
                    flexDirection: "column",
                    maxWidth: "775px",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    justifyContent: "space-between",
                    gap: "20px",
                }}
            >
                {whyAreWeRetrofittingOurHome && (
                    <div
                        style={{
                            flex: "1",
                        }}
                    >
                        <div
                            style={{
                                background: "#93BB49",
                                padding: "15px 0",
                                textAlign: "center",
                            }}
                        >
                            <h1
                                style={{
                                    fontSize: "26px",
                                    fontWeight: "800",
                                    color: "#626261",
                                    textTransform: "uppercase",
                                }}
                            >
                                Why are we retrofitting our home?
                            </h1>
                        </div>
                        <p
                            style={{
                                marginTop: "15px",
                                fontSize: "16px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                            }}
                        >
                            {whyAreWeRetrofittingOurHome}
                        </p>
                    </div>
                )}
                {whatLessonsDidWeLearn && (
                    <div
                        style={{
                            flex: "1",
                        }}
                    >
                        <div
                            style={{
                                background: "#93BB49",
                                padding: "15px 0",
                                textAlign: "center",
                            }}
                        >
                            <h1
                                style={{
                                    fontSize: "26px",
                                    fontWeight: "800",
                                    color: "#626261",
                                    textTransform: "uppercase",
                                }}
                            >
                                What lessons did we learn?
                            </h1>
                        </div>
                        <p
                            style={{
                                marginTop: "15px",
                                fontSize: "16px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                            }}
                        >
                            {whatLessonsDidWeLearn}
                        </p>
                    </div>
                )}
                {whatElseNeedsToBeDone && (
                    <div
                        style={{
                            flex: "1",
                        }}
                    >
                        <div
                            style={{
                                background: "#93BB49",
                                padding: "15px 0",
                                textAlign: "center",
                            }}
                        >
                            <h1
                                style={{
                                    fontSize: "26px",
                                    fontWeight: "800",
                                    color: "#626261",
                                    textTransform: "uppercase",
                                }}
                            >
                                What else needs to be done to get to net zero?
                            </h1>
                        </div>
                        <p
                            style={{
                                marginTop: "15px",
                                fontSize: "16px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                            }}
                        >
                            {whatElseNeedsToBeDone}
                        </p>
                    </div>
                )}
            </div>
            <img src={FooterImage} alt="footer" />
        </div>
    );
};

export default NZReportPDFPage4;
